import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HostListener } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private isMobile = window.innerWidth <= 768;
  private _isOpen = new BehaviorSubject<boolean>(!this.isMobile);
  isOpen$ = this._isOpen.asObservable();

  constructor() {
    window.addEventListener('resize', this.onResize.bind(this));
  }

  private onResize(): void {
    const isCurrentlyMobile = window.innerWidth <= 768;
    if (this.isMobile !== isCurrentlyMobile) {
      this.isMobile = isCurrentlyMobile;
      // Default to closed on mobile, open on desktop when resizing
      this._isOpen.next(!this.isMobile);
    }
  }

  toggle(): void {
    this._isOpen.next(!this._isOpen.value);
  }

  open(): void {
    this._isOpen.next(true);
  }

  close(): void {
    this._isOpen.next(false);
  }

  isOpen(): boolean {
    return this._isOpen.value;
  }
}